import React, { useState } from 'react';
import TitleConfig from '../Components/titleConfig';
import CardConfig from '../Components/cardsConfig';
import Modal from '../Components/modalConfigAS1';

const Bulletin = () => {
  const [showDecRules, setShowDecRules] = useState(false);
  const [card, setCard] = useState({
    id: 3,
    title: 'Boletines de Inversión',
    link: "MODIFICAR PDF"
  });
  const [idConfig, setIdConfig] = useState(0);
  let openModal = () => {
    setShowDecRules(true);
    setIdConfig(idConfig);
  };
  let onCloseModal = () => {
    setShowDecRules(false);
  };

  return (
    <>
     <div className="configHome">
     <TitleConfig title="Boletines de Inversión" />
      <div className="configHome__container">
        <CardConfig item={card} openModal={openModal} />
        <Modal
          close={onCloseModal}
          open={showDecRules}
          idConfig={idConfig}
          title={'Boletines de Inversión'}
          type={'RI'}
          typeFile={'pdf'}
          subtitle={'Cargue aquí los Boletines de Inversión '}
        />
      </div>
    </div>
    </>
  );
};

export default Bulletin;
